module.exports = __webpack_public_path__ + "img/marker-point-verde-lima.68e3fc98.png";